import React from 'react';
import { Container } from 'styles/Styles.styled';
import { H1NewUI } from 'styles/v2/Styles.styled';

const NotFoundPage: React.FC = () => {
  return (
    <Container>
      <div>
        <H1NewUI>404</H1NewUI>
        <p>Sorry, we can not find the page you were looking for.</p>
      </div>
    </Container>
  );
};

export default NotFoundPage;
